import React, { useState, ChangeEvent } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Title, Input } from '../../components';
import LogoEN from '../../assets/logo-en-svg';
import LogoAR from '../../assets/logo-ar-svg';
import { BRAND_NAME } from '../../config/brand';
import './index.css';

const { api } = require('@cashew/utils');

const ns = 'forgot-password-new';

export default () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();
  const { language } = useSelector((state: any) => state.user);
  const isEn = language !== 'ar';
  const Logo = isEn ? LogoEN : LogoAR;
  const year = new Date().getFullYear();

  return (
    <>
      <Helmet bodyAttributes={{ class: 'dark forgot-password' }}>
        <title>Forgot Password</title>
      </Helmet>
      <div className={ns}>
        <div className={`${ns}__container`}>
          <aside className={`${ns}__left`} aria-hidden="true">
            <Logo className={`${ns}__brand-logo`} />
          </aside>
          <section className={`${ns}__right`}>
            <div className={`${ns}__form-container`}>
              <Logo className={`${ns}__logo--mobile`} />
              <div className={`${ns}__title-box`}>
                <Title>Forgot Password</Title>
                <p className={`${ns}__lede`}>
                  Enter the email you used to sign up and we&apos;ll send you a
                  link to reset your password.
                </p>
              </div>
              <form
                className={`${ns}__form`}
                onSubmit={(e) => {
                  e.preventDefault();
                  if (submitting || !email) return;
                  setSubmitting(true);
                  api
                    .post({
                      endpoint: 'identity/cashew/password/token',
                      params: { username: email },
                    })
                    .then(() => {
                      dispatch({
                        type: 'OPEN_TOASTER',
                        payload: {
                          toasterTitle: 'Request password',
                          toasterMessage:
                            'We sent an email with a token to set a new password',
                          toasterType: 'success',
                          toasterVisible: true,
                          toasterDismiss: null,
                        },
                      });
                    })
                    .catch(() => {
                      dispatch({
                        type: 'OPEN_TOASTER',
                        payload: {
                          toasterTitle: 'Request password',
                          toasterMessage: 'Error requesting token',
                          toasterType: 'error',
                          toasterVisible: true,
                          toasterDismiss: null,
                        },
                      });
                    })
                    .finally(() => setSubmitting(false));
                }}
              >
                <Input
                  name="email"
                  placeholder="E-mail"
                  value={email}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    setEmail(e.target.value.replace(/\s/g, ''));
                  }}
                />
                <button
                  type="submit"
                  className="btn btn-black"
                  disabled={submitting || !email}
                >
                  {submitting ? 'Sending…' : 'Send reset link'}
                </button>
                <p className={`${ns}__back gap-2`}>
                  Remembered your password?{' '}
                  <Link to={`/${isEn ? 'en' : 'ar'}/login`}>Back to login</Link>
                </p>
              </form>
            </div>
            <footer className={`${ns}__copy`}>
              ©{year} {BRAND_NAME}. All Rights Reserved.
            </footer>
          </section>
        </div>
      </div>
    </>
  );
};
